import { useNavigate } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import { DataTable } from "./DataTable";

const columns = [
  { accessorKey: "name", header: "Name", meta: { minWidth: 150 } },
  { accessorKey: "yourid", header: "Wearer ID", meta: { minWidth: 150 } },
  { accessorKey: "wardrobename", header: "Wardrobe", meta: { minWidth: 250 } },
  { accessorKey: "branchname", header: "Branch", meta: { minWidth: 200 } },
  { accessorKey: "contractname", header: "Contract", meta: { minWidth: 150 } },
  { accessorKey: "blocked", header: "Blocked", meta: { minWidth: 100 } },
];

export const StaffTable = ({
  data,
  loading,
  selectStaff,
  selectedStaff,
  staffFilter,
  setStaffFilter,
  setSelectedRows,
  selectedRows,
}) => {
  const navigate = useNavigate();

  const staff = data?.staff || [];
  const rowCount = Number(data?.paging?.noOfRecords) || 0;
  const selectedStaffNo = selectedStaff?.map((member) => member.no) || [];

  const pagination = {
    page: (staffFilter?.page ?? 1) - 1,
    pageSize: staffFilter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setStaffFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  // Only rows that are not blocked and haven't already been selected can be
  // selected (creating orders only).
  const isRowSelectable = (row) => {
    if (row.blocked === "Yes") return false;
    return !selectedStaffNo.some((element) => row.staffid.includes(element));
  };

  return (
    <Box sx={{ height: "100%" }}>
      <DataTable
        aria-label="Staff"
        columns={columns}
        rows={staff}
        getRowId={(row) => row.staffid}
        rowCount={rowCount}
        page={pagination.page}
        pageSize={pagination.pageSize}
        loading={loading}
        onPaginationChange={handlePaginationChange}
        onRowClick={
          selectStaff
            ? undefined
            : (row) => navigate({ to: `/staff/${row.staffid}` })
        }
        selectable
        selectedIds={selectedRows}
        onSelectionChange={setSelectedRows}
        isRowSelectable={isRowSelectable}
        selectOnRowClick={selectStaff}
      />
    </Box>
  );
};

// branchid
// branchname
// contract
// contractcode
// contractname
// entComplete
// entExceeded
// entRemaining
// gender
// name
// staffid
// uniform
// wardrobename
// yourid
